export default __webpack_public_path__ + "static/media/facebookColorfulLogo.2aed5109.png";